import {
  boolean,
  index,
  integer,
  pgTable,
  primaryKey,
  text,
  timestamp,
} from "drizzle-orm/pg-core";
import { nanoid } from "nanoid";
import { user } from "./auth";
import { customers } from "./customers";
import { orders } from "./orders";

export const promotions = pgTable(
  "promotions",
  {
    id: text("id")
      .primaryKey()
      .$defaultFn(() => nanoid()),
    name: text("name").notNull(),
    imageUrl: text("image_url"),
    type: text("type", {
      enum: ["PERCENT", "FIXED", "BXGY", "SET"],
    }).notNull(),
    startAt: timestamp("start_at", {
      withTimezone: true,
      mode: "date",
    }).notNull(),
    endAt: timestamp("end_at", {
      withTimezone: true,
      mode: "date",
    }).notNull(),
    minOrderTotal: integer("min_order_total"),
    /** สำหรับ type=PERCENT (1-100) */
    percentValue: integer("percent_value"),
    /** สำหรับ type=FIXED (จำนวนเงิน LAK) */
    fixedAmount: integer("fixed_amount"),
    perCustomerLimit: integer("per_customer_limit"),
    globalLimit: integer("global_limit"),
    priority: integer("priority").notNull().default(0),
    showOnOpen: boolean("show_on_open").notNull().default(false),
    repeatOnOpen: boolean("repeat_on_open").notNull().default(true),
    sendPush: boolean("send_push").notNull().default(false),
    pushSentAt: timestamp("push_sent_at", {
      withTimezone: true,
      mode: "date",
    }),
    isActive: boolean("is_active").notNull().default(true),
    createdAt: timestamp("created_at", {
      withTimezone: true,
      mode: "date",
    }).notNull(),
    updatedAt: timestamp("updated_at", {
      withTimezone: true,
      mode: "date",
    }).notNull(),
  },
  (t) => [
    index("promotions_active_dates_idx").on(t.isActive, t.startAt, t.endAt),
  ],
);

export const promotionPopupDismissals = pgTable(
  "promotion_popup_dismissals",
  {
    userId: text("user_id")
      .notNull()
      .references(() => user.id, { onDelete: "cascade" }),
    promotionId: text("promotion_id")
      .notNull()
      .references(() => promotions.id, { onDelete: "cascade" }),
    dismissedAt: timestamp("dismissed_at", {
      withTimezone: true,
      mode: "date",
    }).notNull(),
  },
  (t) => [
    primaryKey({ columns: [t.userId, t.promotionId] }),
    index("promotion_popup_dismissals_promotion_idx").on(t.promotionId),
    index("promotion_popup_dismissals_user_idx").on(t.userId),
  ],
);

export const promotionScopes = pgTable(
  "promotion_scopes",
  {
    id: text("id")
      .primaryKey()
      .$defaultFn(() => nanoid()),
    promotionId: text("promotion_id")
      .notNull()
      .references(() => promotions.id, { onDelete: "cascade" }),
    scopeType: text("scope_type", {
      enum: ["BRANCH", "PRODUCT", "CATEGORY"],
    }).notNull(),
    scopeId: text("scope_id").notNull(),
    createdAt: timestamp("created_at", {
      withTimezone: true,
      mode: "date",
    }).notNull(),
  },
  (t) => [
    index("promotion_scopes_promotion_idx").on(t.promotionId),
    index("promotion_scopes_scope_idx").on(t.scopeType, t.scopeId),
  ],
);

export const promotionCoupons = pgTable(
  "promotion_coupons",
  {
    id: text("id")
      .primaryKey()
      .$defaultFn(() => nanoid()),
    promotionId: text("promotion_id")
      .notNull()
      .references(() => promotions.id, { onDelete: "cascade" }),
    code: text("code").notNull(),
    maxRedemptions: integer("max_redemptions"),
    perCustomerLimit: integer("per_customer_limit"),
    isActive: boolean("is_active").notNull().default(true),
    createdAt: timestamp("created_at", {
      withTimezone: true,
      mode: "date",
    }).notNull(),
    updatedAt: timestamp("updated_at", {
      withTimezone: true,
      mode: "date",
    }).notNull(),
  },
  (t) => [
    index("promotion_coupons_promotion_idx").on(t.promotionId),
    index("promotion_coupons_code_idx").on(t.code),
  ],
);

export const promotionRedemptions = pgTable(
  "promotion_redemptions",
  {
    id: text("id")
      .primaryKey()
      .$defaultFn(() => nanoid()),
    promotionId: text("promotion_id")
      .notNull()
      .references(() => promotions.id, { onDelete: "cascade" }),
    customerId: text("customer_id").references(() => customers.id, {
      onDelete: "set null",
    }),
    orderId: text("order_id")
      .notNull()
      .references(() => orders.id, { onDelete: "cascade" }),
    couponCode: text("coupon_code"),
    discountAmount: integer("discount_amount").notNull(),
    createdAt: timestamp("created_at", {
      withTimezone: true,
      mode: "date",
    }).notNull(),
  },
  (t) => [
    index("promotion_redemptions_promotion_idx").on(t.promotionId),
    index("promotion_redemptions_order_idx").on(t.orderId),
    index("promotion_redemptions_customer_idx").on(t.customerId),
  ],
);
